import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
class Report {
    static getReports(organizationsArray, isAdmin) {
        const endpoint = formatEndpoint(endpoints.report.getReports, { isAdmin });
        const organizations = organizationsArray.map((organization) => organization.organizationID.toString());
        return RestManagerWithoutBaseUrl.post(endpoint, { organizations });
    }

    static downloadReport(reportId) {
        const endpoint = formatEndpoint(endpoints.report.downloadReport, { reportId });
        return RestManagerWithoutBaseUrl.post(endpoint);
    }

    static generateReport(reportTypeIdentifier, assetIdentifier, measurementUnit, rawDataTimestamp, reportingPeriod) {
        const endpoint = formatEndpoint(endpoints.report.generateReport);
        return RestManagerWithoutBaseUrl.post(endpoint, {
            reportTypeIdentifier,
            assetIdentifier,
            measurementUnit,
            ...rawDataTimestamp ? { rawDataTimestamp } : {},
            ...reportingPeriod ? {
                reportStartDate: reportingPeriod.from,
                reportEndDate: reportingPeriod.to
            } : {}
        });
    }

    static uploadReport(reportUploadParams) {
        const endpoint = formatEndpoint(endpoints.report.uploadReport);
        return RestManagerWithoutBaseUrl.post(endpoint, reportUploadParams);
    }

    static uploadReportInit(reportUploadInitParams) {
        const endpoint = formatEndpoint(endpoints.report.uploadReportInit);
        return RestManagerWithoutBaseUrl.post(endpoint, reportUploadInitParams);
    }

    static publishReport(reportId) {
        const endpoint = formatEndpoint(endpoints.report.publishReport, { reportId });
        return RestManagerWithoutBaseUrl.put(endpoint);
    }

    static rejectReport(reportId) {
        const endpoint = formatEndpoint(endpoints.report.rejectReport, { reportId });
        return RestManagerWithoutBaseUrl.put(endpoint);
    }

    static generateFleetReport(generateFleetReportParams) {
        const endpoint = formatEndpoint(endpoints.report.generateFleetReport);
        return RestManagerWithoutBaseUrl.post(endpoint, generateFleetReportParams);
    }

    static deleteReport(reportId, organizationId) {
        const endpoint = formatEndpoint(endpoints.report.deleteReport, { reportId, organizationId });
        return RestManagerWithoutBaseUrl.put(endpoint);
    }

    static getRawDataCollections(assetId, startTime, endTime) {
        const endpoint = formatEndpoint(endpoints?.report?.rawDataCollections, { assetId, startTime, endTime });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }
}

export default Report;
